import React, { useState, useEffect } from "react";
import "../Footer/footer.css";
import { Col, Container, Row, ListGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      setVisible(document.documentElement.scrollTop > 300);
    };
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="pt-5 pb-4">
        <Container>
          <Row className="gy-4">
            <Col md="3">
              <h4>Company</h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/about-us">About Us</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/faq">FAQs</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/terms-conditions">Terms</NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>

            <Col md="3">
              <h4>Explore</h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/benefits">Benefits</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/enquiry">Enquiry</NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>

            <Col md="3">
              <h4>Quick Links</h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/">Home</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/contact">Contact Us</NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>

            <Col md="3" className="location">
              <h4>Contact Info</h4>

              <p>B12, 2nd Floor, Panchsheel Enclave New Delhi-110017</p>
              <p>GST NUMBER : 07AKEPM1902B1ZT</p>

              <div className="my-2">
                <div className="d-flex align-items-center">
                  <i className="bi bi-envelope me-2"></i>
                  <a href="mailto:bipnesh@brtravels.co.in">
                    bipnesh@brtravels.co.in
                  </a>
                </div>

                <div className="d-flex align-items-center">
                  <i className="bi bi-envelope me-2"></i>
                  <a href="mailto:ops@brtravels.co.in">ops@brtravels.co.in</a>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <i className="bi bi-telephone me-2"></i>
                <a href="tel:+919650801697">+91 9650801697</a>
              </div>
            </Col>
          </Row>

          <Row className="pt-4 mt-4 bdr">
            <Col className="text-center">
              <p className="copyright">
                © {new Date().getFullYear()} brtravels.co.in – All Rights
                Reserved. | Designed & Developed By InfraSpark IT Solutions 
              </p>

            </Col>
          </Row>
        </Container>
      </footer>

      <div
        id="back-top"
        onClick={scrollTop}
        className={visible ? "active" : ""}
      >
        <i className="bi bi-arrow-up"></i>
      </div>
    </>
  );
};

export default Footer;
